module.exports = __webpack_public_path__ + "img/reddit.a7e99978.svg";